<template>
  <v-autocomplete
    variant="outlined"
    density="compact"
    v-model="inputValue"
    v-bind:items="occupations"
    v-bind:item-title="(item) => objectTranslator(item, 'OCCUPATION_NAME')"
    v-bind:item-value="(item) => item.OCCUPATION_ID"
    v-bind:rules="rules"
  ></v-autocomplete>
</template>

<script>
import { objectTranslator } from "@/helper/translator";
import validator from "@/helper/validator";

export default {
  name: "OccupationCard",
  props: {
    modelValue: String,
  },

  data: () => ({
    rules: [validator.required],
  }),

  methods: {
    objectTranslator,
  },

  computed: {
    occupations: function () {
      return this.$store.state.ref.occupations;
    },

    inputValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },

  created() {
    this.$store.dispatch("ref/getOccupations");
  },
};
</script>
